// Shared Google Maps setup for every in-app map that should look and load
// the same way (web lead map, fleet vehicle map).
//
// The Maps JS script can only be loaded once per page, so every
// useJsApiLoader() call must pass these exact options — a second loader with
// a different id/key/libraries throws "Loader must not be called again with
// different options".

// Browser keys are public by nature, but this one should carry an
// HTTP-referrer restriction and live in the environment rather than in git.
// The literal stays as a fallback so existing deploys keep working.
const MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_KEY ||
  "AIzaSyBTcKskEQngUy4qAvParxaR87TYmt-cwvE";

export const MAPS_LOADER_OPTIONS = {
  id: "google-map-script",
  googleMapsApiKey: MAPS_API_KEY,
};

// Second loader for pages that need address autocomplete or geocoding (SBCF
// spec sheet, snow load map, geomapping). This key is the one with the
// Places and Geocoding APIs enabled; the key above has neither. Same rule:
// every page on this loader passes this exact object.
//
// The two loaders can't both run in one page session — moving between a
// page on each throws the "different options" error until a reload.
const PLACES_LIBRARIES = ["places"];
export const PLACES_LOADER_OPTIONS = {
  googleMapsApiKey:
    process.env.REACT_APP_GOOGLE_PLACES_KEY ||
    "AIzaSyD7V3kda1ymJxGDw3pnRP1gippSe7SmEsI",
  libraries: PLACES_LIBRARIES,
};

// Muted basemap so the pins are the loudest thing on the page. The dark
// variant follows the in-app toggle, not the OS.
export const MAP_STYLE_LIGHT = [
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  { featureType: "landscape", stylers: [{ saturation: -40 }] },
];

export const MAP_STYLE_DARK = [
  ...MAP_STYLE_LIGHT,
  { elementType: "geometry", stylers: [{ color: "#1f2937" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#94a3b8" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#0f172a" }] },
  { featureType: "water", stylers: [{ color: "#0f172a" }] },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#334155" }],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{ color: "#475569" }],
  },
];
